import { render, staticRenderFns } from "./DeviceSummary.vue?vue&type=template&id=15637be4&scoped=true&lang=pug"
import script from "./DeviceSummary.js?vue&type=script&lang=js&external"
export * from "./DeviceSummary.js?vue&type=script&lang=js&external"
import style0 from "./DeviceSummary.sass?vue&type=style&index=0&id=15637be4&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15637be4",
  null
  
)

export default component.exports